import { render, staticRenderFns } from "./DataCenterLayout.vue?vue&type=template&id=0baa0bf7&scoped=true&"
import script from "./DataCenterLayout.vue?vue&type=script&lang=js&"
export * from "./DataCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./DataCenterLayout.vue?vue&type=style&index=0&id=0baa0bf7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa0bf7",
  null
  
)

export default component.exports